import React from 'react';

import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';

const BoardTemplatePickerCloseButton = ({
    selectTemplate,
    dismissTemplatePicker,
}: {
    selectTemplate: (templateId: string | null) => void;
    dismissTemplatePicker: () => void;
}) => {
    return (
        <Button
            className="close-button"
            onClickFn={() => {
                selectTemplate(null);
                dismissTemplatePicker();
            }}
        >
            <Icon name="close-x" />
        </Button>
    );
};

export default BoardTemplatePickerCloseButton;
